import React, { useState } from "react";
import { Dialog, DialogType, DialogFooter } from "@fluentui/react/lib/Dialog";
import { DefaultButton, PrimaryButton } from "@fluentui/react/lib/Button";
import { TextField } from "@fluentui/react/lib/TextField";
import Select from "react-select";
import { Label, MessageBar, MessageBarType } from "office-ui-fabric-react";
import { getCluaseLibraryData } from "../Utils/CommonFunctions";
let libraryData:any
const ClauseLibrary = ({ open, onClose, setMessage }) => {
  const [selectedClause, setSelectedClause] = React.useState({ clauseType: "", Tags: "" });
  const [clauseTypesOptions, setClauseTypesOptions] = React.useState([]);
  const [showErrors, setShowErrors] = React.useState({ clauseType: false, tags: false });
  React.useEffect(() => {
    fetchClauseData();
  }, []);

  async function fetchClauseData() {
    await getCluaseLibraryData()
      .then((data: any) => {
        libraryData=data;
        const clauseTypes = Array.from(new Set(data.map((i) => i.clauseType))).map((clauseType) => ({
          label: clauseType,
          value: clauseType,
        }));
        setClauseTypesOptions(clauseTypes);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  const fetchMessages = () => {
    const { clauseType, Tags } = selectedClause;
    if (clauseType && Tags) {
      const selectedData = libraryData.filter(
        (i) => i.tags.toLowerCase().trim()?.includes(Tags.toLowerCase()) && i.clauseType === clauseType) || [] ;
      if (selectedData.length) {
        setMessage({defaultmessages: selectedData.flatMap(i => i.message)
            .filter(msg => msg.favorite)
            .map(e => e.rted)
            .map(e => e.replace(/<[^>]*>/g, ' '))
            .map(e => {
              const trimmed = e.trim();
              return { key: trimmed, text: trimmed, Message: trimmed };
            }),
          altmessages: selectedData.flatMap(i => i.message).filter(msg => !msg.favorite)
            .map(e => e.rted)
            .map(e => e.replace(/<[^>]*>/g, ' '))
            .map(e => {
              const trimmed = e.trim();
              return { key: trimmed, text: trimmed, Message: trimmed };
            })
        });               
        setSelectedClause({clauseType: '', Tags: ''})
      }
    }
  };
  const handleClauseChange = (e, c) => {
    let value;
    if (c === "clauseType") {
      value = e?.value;
    } else if (c === "Tags") {
      value = e.target.value;
    }

    setSelectedClause((prevState) => ({
      ...prevState,
      [c]: value,
    }));
  };
  const handleSubmit = () => {
    const errors = {
      clauseType: !selectedClause.clauseType.trim(),
      tags: !selectedClause.Tags.trim(),
    };
    setShowErrors(errors);
    if (!errors.clauseType && !errors.tags) {
      fetchMessages();
      onClose()
    }
  };

  return (
    <Dialog
      hidden={!open}
      onDismiss={onClose}
      dialogContentProps={{
        title: "Get from clause library",
      }}
    >
      <div>
        <Label required>Clause Type</Label>
        <Select
          value={clauseTypesOptions?.find((ele) => ele.value == selectedClause.clauseType)}
          onChange={(e) => handleClauseChange(e, "clauseType")}
          options={clauseTypesOptions}
          placeholder="Select Clause Type"
          maxMenuHeight={100}
        />
        {showErrors.clauseType && (
          <MessageBar
            messageBarType={MessageBarType.error}
            styles={{ content: { display: "flex !important", justifyContent: "flex-start !important" } }}
          >
            Clause Type is required.
          </MessageBar>
        )}
        <Label required>Tags</Label>
        <TextField
          value={selectedClause.Tags}
          onChange={(e) => handleClauseChange(e, "Tags")}
          placeholder="Enter Clause Tags"
        />
        {showErrors.tags && (
          <MessageBar
            messageBarType={MessageBarType.error}
            styles={{ content: { display: "flex !important", justifyContent: "flex-start !important" } }}
          >
            Tags are required.
          </MessageBar>
        )}
      </div>
      <div style={{ display: "flex", gap: "10px", marginTop: "15px", justifyContent: "center" }}>
        <PrimaryButton text="Submit" onClick={handleSubmit}/>
        <DefaultButton onClick={onClose} text="Cancel" />
      </div>
    </Dialog>
  );
};

export default ClauseLibrary;
